export const API_URL = 'https://api.fantasyworldtrpg.cz/battle';

function withToken(path) {
    const t = localStorage.getItem('fwb_token');
    if (!t) return `${API_URL}${path}`;
    const sep = path.includes('?') ? '&' : '?';
    return `${API_URL}${path}${sep}token=${encodeURIComponent(t)}`;
}

export async function apiGet(path) {
    const res = await fetch(withToken(path));
    if (!res.ok) throw new Error('API failed');
    return res.json();
}

export async function apiPost(path, data) {
    const res = await fetch(withToken(path), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('API failed');
    return res.json();
}
